/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t){return"point"===t.type}export{t as isDehydratedPoint};
